import React from "react";
import { makeStyles } from "@material-ui/styles";
import { useHistory } from "react-router-dom";

const useStyles = makeStyles({
  container: {
    width: 160,
    height: "100%",
    backgroundImage: `url("/images/upkp/logo_persiapanupkp.svg")`,
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center",
    cursor: "pointer",
  },
});

export default function () {
  const classes = useStyles();
  const history = useHistory();

  const handleClick = () => {
    history.push("/");
  };

  return <div className={classes.container} onClick={handleClick}></div>;
}
